import { Container, Row, Col } from "react-bootstrap";
import React, { useState, useEffect } from "react";

import correo from "../images/icons/btn-mail-white.png";
import telefono from "../images/icons/btn-llamada-white.png";
import whatsapp from "../images/icons/btn-wup-white.png";

import ImageMovil from "./widgets/basico/imageMovil";
import * as stylesModule from "../styles/styles-header-footer.module.css";
import TagManager from 'react-gtm-module';

import WA from "../images/icons/whatsapp-alt-1.png"
import PH from "../images/icons/phone-alt-1.png"

export default function FooterMobile ({barraNavegacion, landingAutos}){

    const [ contacto, setContacto ] = useState();

    const dataContacto = [
        {nombre: "correo",img: "btn-mail-white.png", href: "mailto:informes@gruporivero.com"},
        {nombre: "telefono",img: "btn-llamada-white.png", href: "tel:8112571257"},
        {nombre: "whatsapp",img: "btn-wup-white.png", href: "https://wa.me/+5218116001600"}
    ];

    const object = [
        {nombre: "Principal", tagCss: "principal"},
        {nombre: "Cotiza en línea", tagCss: "cotiza"},
        {nombre: "Características", tagCss: "caracteristicas"},
        {nombre: "Galería", tagCss: "galeria"},
        {nombre: "Versiones", tagCss: "versiones"}
    ];

    let tagManagerArgs = {
        gtmId: 'GTM-W7HQJGC6', //Este ID se obtiene en el admin de GTM
        dataLayer: {
            'event': contacto,
        }
    }

    useEffect (() => {

        if (tagManagerArgs.dataLayer.event != undefined){
            //console.log(tagManagerArgs, "Analytics");
            TagManager.initialize(tagManagerArgs);
        }
    }, [tagManagerArgs]);

    function sendData(num){ 
        setContacto(num);
    }

    const opcionesFooter = dataContacto.map((obj, i) => {
        var col = "";
        if(i % 3){
            col = <div style={{width:'1%'}}><div className={stylesModule.footerDivision}></div></div>
        }
        return(
            <>
            {col}
            <Col key={i}>
                <a href={obj.href} data-metakey="mobile-btn-wup" target="_blank" rel="noreferrer" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <ImageMovil 
                        fileName={obj.img} 
                        alt={`boton footer ${obj.nombre}`} 
                        style={{width: '35%', height: '100%'}}
                    />
                </a>
            </Col>
            </>
        )
    });
    //COMENTADO ES OPCION NAVEGANTE PARA LANDING AUTOS CHEVROLET
    /*const opcionesNavegante = object.map((obj, i) => {
        return(
            <p key={i} id="footerSeccionBox" onClick={() => barraNavegacion(obj.nombre)}>
                {obj.nombre}
            </p>
        )
    })*/

    //Funcion Toggle para mostrar las opciones de navegación 
    /*var toggle = false;
    function onchangeDrop(evt){
      toggle =!toggle
      var element = document.getElementById("footerOpcionesNavegar");
      var partes = document.getElementById("footerDivBox");
      element.classList.toggle("is-active")
  
      if(partes.style.display == "none") {
          partes.style.display = "block";
        }else{
          partes.style.display = "none";
        }
  
    }*/

    return(
        <>
            <div className={stylesModule.footerAreaMobil}>
                <Row style={{display: 'flex', alignItems: 'center', height: '100%'}}>
                    <Col style={{backgroundColor: '#2482f8', height: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center'}} lg={6} md={6} sm={6} xs={6}>
                        <a style={{display: 'flex'}} onClick={() => sendData('dd_tel_1257')} href="tel:8112571257">
                            <img src={PH} alt="telefono" style={{width: 30}}/>
                            <p className="m-0" style={{color:"white", fontWeight: 'bold', fontSize: '1.4em'}}>¡Llámanos!</p>
                        </a>
                    </Col>
                    <Col style={{backgroundColor: '#2b9c1f', height: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center'}} lg={6} md={6} sm={6} xs={6}>
                        <a style={{display: 'flex'}} onClick={() => sendData('dd_whatsapp_8116001600')} href="https://wa.me/+5218116001600" target="_blank" rel="noreferrer">
                            <img src={WA} alt="whatsapp" style={{width: 30}}/>
                            <p  className="m-0" style={{color:"white", fontWeight: 'bold', fontSize: '1.4em'}}>WhatsApp</p>
                        </a>
                    </Col>
                    {/*{opcionesFooter}
                    landingAutos === true ? (
                        <>
                            <div style={{width:'1%'}}><div className="footerDivision"></div></div>
                            <Col className="footerOpcionesMovil" onClick={() => {onchangeDrop()}}>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={whatsapp} alt="whatsapp" style={{width: 35}} />
                                </div>
                                <div id="footerOpcionesNavegar">
                                    <div id="footerDivBox" style={{display: "none"}}>
                                        {opcionesNavegante}
                                    </div>
                                </div>
                            </Col>
                        </>
                    ) : null */}
                </Row>
            </div>
        </>
    )

}